/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type {
    MutationFunction,
    QueryClient,
    UseMutationOptions,
    UseMutationResult,
} from '@tanstack/react-query'

import type {
    ClientEventRequestDTO,
    DeleteRequestClientEventMemoryDeletionParams,
    HTTPValidationErrorDTO,
    PostRequestClientEventParams,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * This call is used to send client event information. Each message can contain multiple client behavior information.

 * @summary Post Client Event
 */
export const postRequestClientEvent = (
    clientEventRequestDTO: BodyType<ClientEventRequestDTO>,
    params: PostRequestClientEventParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/client_event`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: clientEventRequestDTO,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestClientEventMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestClientEvent>>,
        TError,
        {
            data: BodyType<ClientEventRequestDTO>
            params: PostRequestClientEventParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestClientEvent>>,
    TError,
    {
        data: BodyType<ClientEventRequestDTO>
        params: PostRequestClientEventParams
    },
    TContext
> => {
    const mutationKey = ['postRequestClientEvent']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestClientEvent>>,
        {
            data: BodyType<ClientEventRequestDTO>
            params: PostRequestClientEventParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestClientEvent(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestClientEventMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestClientEvent>>
>
export type PostRequestClientEventMutationBody = BodyType<ClientEventRequestDTO>
export type PostRequestClientEventMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Client Event
 */
export const usePostRequestClientEvent = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestClientEvent>>,
            TError,
            {
                data: BodyType<ClientEventRequestDTO>
                params: PostRequestClientEventParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestClientEvent>>,
    TError,
    {
        data: BodyType<ClientEventRequestDTO>
        params: PostRequestClientEventParams
    },
    TContext
> => {
    const mutationOptions = getPostRequestClientEventMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * This call is used to delete viewed memory client events for the user.

 * @summary Delete Memory Client Event
 */
export const deleteRequestClientEventMemoryDeletion = (
    params: DeleteRequestClientEventMemoryDeletionParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown>(
        { url: `/client_event/memory_deletion`, method: 'DELETE', params },
        options,
    )
}

export const getDeleteRequestClientEventMemoryDeletionMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestClientEventMemoryDeletion>>,
        TError,
        { params: DeleteRequestClientEventMemoryDeletionParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestClientEventMemoryDeletion>>,
    TError,
    { params: DeleteRequestClientEventMemoryDeletionParams },
    TContext
> => {
    const mutationKey = ['deleteRequestClientEventMemoryDeletion']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestClientEventMemoryDeletion>>,
        { params: DeleteRequestClientEventMemoryDeletionParams }
    > = (props) => {
        const { params } = props ?? {}

        return deleteRequestClientEventMemoryDeletion(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestClientEventMemoryDeletionMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestClientEventMemoryDeletion>>
>

export type DeleteRequestClientEventMemoryDeletionMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Delete Memory Client Event
 */
export const useDeleteRequestClientEventMemoryDeletion = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestClientEventMemoryDeletion>>,
            TError,
            { params: DeleteRequestClientEventMemoryDeletionParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestClientEventMemoryDeletion>>,
    TError,
    { params: DeleteRequestClientEventMemoryDeletionParams },
    TContext
> => {
    const mutationOptions =
        getDeleteRequestClientEventMemoryDeletionMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
